/* ALB Produkt-Grid Tabs (sections/alb-product-grid-tabs.liquid, 2026-09-23)
   Pillen = Tabs nach dem WAI-ARIA-Tabs-Pattern: Klick, Pfeiltasten, Home/End wechseln
   den Tab; nur das aktive Panel ist sichtbar (hidden-Attribut). Alle Panels sind
   serverseitig gerendert – die Slider darin (alb-pg-slider) messen sich beim Einblenden
   per ResizeObserver selbst nach, hier ist dafuer nichts zu tun.
   Extras: #hash = handleisiertes Tab-Label oeffnet den Tab direkt (Deep-Link, auch bei
   hashchange) und scrollt zur Section; im Theme-Editor oeffnet die Auswahl eines
   Tab-Blocks den Tab. Self-guarded (1x pro Seite), Event-Delegation – funktioniert
   fuer beliebig viele Sections und auch nach Editor-Rerenders. */
(function () {
  if (window.albPgTabsInit) return;
  window.albPgTabsInit = true;

  function tabsOf(list) {
    return Array.prototype.slice.call(list.querySelectorAll('[data-pg-tab]'));
  }

  function activate(tab, focus) {
    var list = tab.closest('[data-pg-tablist]');
    var sec = tab.closest('.alb-pgt');
    if (!list || !sec) return;
    tabsOf(list).forEach(function (t) {
      var on = t === tab;
      t.classList.toggle('is-active', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.setAttribute('tabindex', on ? '0' : '-1');
      var panel = sec.querySelector('[data-pg-panel="' + t.getAttribute('data-pg-tab') + '"]');
      if (panel) panel.hidden = !on;
    });
    if (focus) tab.focus({ preventScroll: true });
    /* Pille im Streifen sichtbar halten, falls der Streifen scrollt (mobil eine Zeile) */
    if (tab.scrollIntoView && list.scrollWidth > list.clientWidth + 2) {
      tab.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    }
  }

  document.addEventListener('click', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-pg-tab]') : null;
    if (tab) activate(tab, false);
  });

  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest ? e.target.closest('[data-pg-tab]') : null;
    if (!tab) return;
    var list = tab.closest('[data-pg-tablist]');
    if (!list) return;
    var tabs = tabsOf(list), i = tabs.indexOf(tab), n = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = tabs[(i + 1) % tabs.length];
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = tabs[(i - 1 + tabs.length) % tabs.length];
    else if (e.key === 'Home') n = tabs[0];
    else if (e.key === 'End') n = tabs[tabs.length - 1];
    if (n) { e.preventDefault(); activate(n, true); }
  });

  /* ---- Deep-Link: #bundles oeffnet die erste Pille mit data-pg-hash="bundles" ----
     Hash-Werte sind handleisiert (a-z, 0-9, Bindestrich) – alles andere wird ignoriert.
     Scrollen wie in alb-anchor-scroll.js: Horizon scrollt ab 990px den .page-wrapper
     (scroll-behavior: smooth), scrollIntoView kennt den verschachtelten Container;
     'instant' statt 'auto', sonst erbt der Sprung das smooth des Containers. Ziel ist
     die Section-Ueberschrift (sonst die Pillen) mit scroll-margin-top fuer den Sticky-Header. */
  function tabFromHash() {
    var h = (location.hash || '').slice(1);
    if (!h || !/^[a-z0-9-]+$/i.test(h)) return null;
    return document.querySelector('[data-pg-tab][data-pg-hash="' + h.toLowerCase() + '"]');
  }

  function jumpTo(tab, smooth) {
    var sec = tab.closest('.alb-pgt');
    var target = sec && (sec.querySelector('.alb-pgt-heading') || tab.closest('[data-pg-tablist]'));
    if (!target || !target.scrollIntoView) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    try {
      target.scrollIntoView({ behavior: smooth && !reduce ? 'smooth' : 'instant', block: 'start' });
    } catch (e) {
      target.scrollIntoView(true);
    }
  }

  /* Direkteinstieg: Tab sofort oeffnen (kein Umspringen), Position erst nach 'load' + einen
     Frame hart setzen – Horizon setzt die Scrollposition beim Laden selbst, und Lazy-Bilder
     darueber verschieben das Ziel bis dahin (gleiches Muster wie alb-anchor-scroll.js). */
  var initial = tabFromHash();
  if (initial) {
    activate(initial, false);
    var jump = function () { window.requestAnimationFrame(function () { jumpTo(initial, false); }); };
    if (document.readyState === 'complete') jump();
    else window.addEventListener('load', jump, { once: true });
  }
  window.addEventListener('hashchange', function () {
    var tab = tabFromHash();
    if (!tab) return;
    activate(tab, false);
    jumpTo(tab, true);
  });

  /* ---- Pillen gleichmaessig umbrechen (Moritz, 2026-09-24) ----
     Brechen die Pillen um, werden sie auf die (natuerliche) Zeilenzahl gleichmaessig verteilt,
     obere Zeilen bekommen den Rest: 4 -> 2+2 statt 3+1, 5 -> 3+2, 7 -> 3+2+2. Umgesetzt mit
     Zeilenumbruch-Elementen (volle Breite); die Zeilenluecke uebernimmt dann das Umbruch-Element
     selbst (row-gap 0), sonst kaeme pro Umbruch eine zweite Luecke dazu. Passt eine erzwungene
     Zeile nicht in die Breite, bleibt es beim natuerlichen Umbruch. Danach feuert
     'alb-pgt:layout' (V2 setzt darauf die Ansicht-Icons neu). */
  function rowsOf(tabs) {
    var tops = [];
    tabs.forEach(function (t) {
      var y = t.offsetTop;
      if (!tops.some(function (v) { return Math.abs(v - y) < 4; })) tops.push(y);
    });
    return tops.length;
  }
  function balance(list) {
    list.querySelectorAll('.alb-pgt-break').forEach(function (b) { b.remove(); });
    list.classList.remove('alb-pgt-tabs--balanced');
    list.style.rowGap = '';
    var tabs = tabsOf(list).filter(function (t) { return t.offsetParent !== null; });
    var n = tabs.length, r = n ? rowsOf(tabs) : 0;
    if (r > 1 && r < n) {
      var gap = getComputedStyle(list).rowGap;
      gap = gap && gap !== 'normal' ? gap : '8px';
      var base = Math.floor(n / r), extra = n % r, idx = 0;
      for (var row = 0; row < r - 1; row++) {
        idx += base + (row < extra ? 1 : 0);
        var br = document.createElement('span');
        br.className = 'alb-pgt-break';
        br.setAttribute('aria-hidden', 'true');
        br.style.cssText = 'flex-basis:100%;width:100%;height:' + gap + ';margin:0;padding:0;';
        tabs[idx].parentNode.insertBefore(br, tabs[idx]);
      }
      list.style.rowGap = '0px';
      list.classList.add('alb-pgt-tabs--balanced');
      if (rowsOf(tabs) !== r) {
        list.querySelectorAll('.alb-pgt-break').forEach(function (b) { b.remove(); });
        list.classList.remove('alb-pgt-tabs--balanced');
        list.style.rowGap = '';
      }
    }
    var ev;
    try { ev = new CustomEvent('alb-pgt:layout', { bubbles: true }); } catch (err) { ev = document.createEvent('Event'); ev.initEvent('alb-pgt:layout', true, false); }
    list.dispatchEvent(ev);
  }
  function balanceAll() {
    document.querySelectorAll('[data-pg-tablist]').forEach(function (list) {
      list.albBalW = list.clientWidth;
      balance(list);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', balanceAll); else balanceAll();
  window.addEventListener('load', balanceAll);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(balanceAll);
  window.addEventListener('resize', function () {
    /* nur bei geaenderter Breite neu verteilen (mobil feuert resize auch beim Scrollen) */
    document.querySelectorAll('[data-pg-tablist]').forEach(function (list) {
      if (list.clientWidth !== list.albBalW) { list.albBalW = list.clientWidth; balance(list); }
    });
  }, { passive: true });
  document.addEventListener('shopify:section:load', balanceAll);

  /* Theme-Editor: Tab-Block auswaehlen = Tab oeffnen (Block-Attribute sitzen auf der Pille) */
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var tab = e.target && e.target.closest ? e.target.closest('[data-pg-tab]') : null;
      if (tab) activate(tab, false);
    });
  }
})();
